import { gql } from '@apollo/client';

export const LIST_ALL_RESOURCES = gql`
  query ListAllResources {
    listAllResources {
      id
      code
      name
      type
      parentId
      parentName
      description
      createdAt
      updatedAt
    }
  }
`;

export interface ResourceType {
  id: number | string;
  code: string;
  name: string;
  type: string;
  parentId?: number | string | null;
  parentName?: string | null;
  description?: string | null;
  createdAt?: number | string | null;
  updatedAt?: number | string | null;
}

export interface ListAllResourcesResponse {
  listAllResources: ResourceType[];
}
